import { render, staticRenderFns } from "./AddTopics.vue?vue&type=template&id=54b3c525&scoped=true&"
import script from "./AddTopics.vue?vue&type=script&lang=js&"
export * from "./AddTopics.vue?vue&type=script&lang=js&"
import style0 from "./AddTopics.vue?vue&type=style&index=0&id=54b3c525&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b3c525",
  null
  
)

export default component.exports